//import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import Loading from '../component/Loading'

//propsの型定義
type Props = {
  children: JSX.Element
}

const PrivateRoute = (props: Props) => {
  const { isAuthenticated, isLoading } = useAuth0()

  //ログイン情報が合った場合
  if (isAuthenticated) {
    //propsで渡されたコンポーネントを表示
    return props.children
  } else {
    //ログイン情報がなかった場合
    return isLoading ? <Loading /> : <Navigate to="/" />
  }
}

export default PrivateRoute
